<main class="forgot-password-container bg-login" [class]="containerClass">
  @if (!isHighlights) {
    <zbp-back-to-website-link class="back-to-website-link"></zbp-back-to-website-link>
  }
  <div
    id="forgotPasswordBody"
    [class.password-reset-flow-form]="!isHighlights"
    class="align-items-center col-md-8 col-lg-6 col-xl-6 col-xxl-6 col-sm-10 col-xs-12"
    >
    <figure class="text-center mx-2">
      <img
        class="brand-logo"
        id="highlightsLogo"
        [attr.alt]="isHighlights ? 'Highlights Portal' : 'My ZB Portal logo'"
        />
    </figure>
    @if (error.processed) {
      <div
        id="error"
        class="alert alert-danger mx-auto"
        role="alert"
        [innerHTML]="error.message"
      ></div>
    }
    @if (formSubmitted.value && !success.processed && !error.processed) {
      <div>
        <div class="preloader spinner">
          <zbp-preloader></zbp-preloader>
        </div>
      </div>
    }
    @if (success?.processed) {
      <div
        id="successContainer"
        class="alert alert-transparent text-center"
        role="alert"
        >
        <zbp-login-information-cta
          iconSrc="assets/img/envelope.png"
          iconAlt="Envelop Icon"
          headingText="Check your email"
          [showSendAgainSection]="true"
          [showBackToLoginLinkButton]="true"
          [bodyHTML]="success?.message"
          (sendAgainClickedHandler)="showForm()"
        ></zbp-login-information-cta>
      </div>
    }
    @if (!formSubmitted.value) {
      <form #ngForm="ngForm"  novalidate="false" (ngSubmit)="triggerSubmitForm$.next(true)"
        id="passwordResetPanel"
        [formGroup]="resetForm"
        [class.px-5]="isHighlights"
        class="w-100"
        >
        <header class="row mt-auto">
          <h1 id="pageTitle" class="h1 text-center">Password Reset</h1>
          <h2 id="titleSubtext" class="h4 text-center">
            Enter the email address associated with your account to reset your password.
          </h2>
        </header>
        <div class="row input-group email-input-section">
          <label for="email" class="form-label form-label-hfc">Email</label>
          <input
            type="text"
            class="form-control form-control-hfc"
            id="email"
            name="email"
            formControlName="email"
            />
          @if (email.invalid && ngForm.submitted) {
            <div class="email-error">
              @if (email.errors?.['required']) {
                <p class="is-invalid-text">Email is required.</p>
              }
              @if (email.errors?.['email']) {
                <p class="is-invalid-text">Invalid Email Format.</p>
              }
            </div>
          }
        </div>
        <div id="forgotPasswordButtonSection" class="row">
          <zbp-button-component
            id="resetSubmit"
            type="submit"
            [disabled]="!ngForm.form.valid"
            label="Reset Password"
            theme="primary"
            [fullWidth]="true"
            [topBottomPaddingSpacingS]="true"
            customClass="reset-button">
          </zbp-button-component>
          <button
            id="resetCancel"
            type="button"
            class="btn btn-link btn-sm mx-2 back-button"
            (click)="cancelResetPasswordMode()"
            >
            <span class="back-arrow" aria-hidden="true">&larr;</span> Back to Login
          </button>
        </div>
      </form>
    }
    @if(isHighlights) {
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    }
  </div>
  @if(!isHighlights) {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  }
</main>

<ng-template #footerTemplate>
  <zbp-footer id="forgotPasswordFooter"></zbp-footer>
</ng-template>
